export const nl = {
  nav: {
    home: 'Home',
    treatments: 'Behandelingen',
    results: 'Resultaten',
    gallery: 'Galerij',
    compare: 'Vergelijk',
    blog: 'Blog',
    locations: 'Locaties',
    contact: 'Contact',
    bookConsultation: 'Gratis Consult',
    hairAnalysis: 'AI Haaranalyse',
  },
  hairTransplant: {
    title: 'FUE Haartransplantatie',
    subtitle: 'Geavanceerde Follicular Unit Extraction gericht op natuurlijk ogende, langdurige resultaten. Individuele uitkomsten variëren.',
    bookConsultation: 'Boek Gratis Consult',
    viewResults: 'Bekijk Resultaten',
    benefits: 'Waarom Kiezen voor FUE Haartransplantatie?',
    process: 'De FUE Procedure Stap voor Stap',
    pricing: 'Transparante Prijspakketten',
    stats: 'Onze Resultaten',
  },
  stemcellTherapy: {
    title: 'Stamceltherapie',
    subtitle: 'Informatieve uitleg over stamcelonderzoek bij haarherstel. Beschikbaarheid hangt af van medische beoordeling en lokale regelgeving.',
    benefits: 'Voordelen van Stamceltherapie',
    howItWorks: 'Hoe Het Werkt',
    pricing: 'Stamceltherapie Pakketten',
    idealFor: 'Wie Moet Stamceltherapie Overwegen?',
  },
  prp: {
    title: 'PRP Haarbehandeling',
    subtitle: 'Plaatjesrijk plasma therapie om natuurlijke haargroei te stimuleren',
    whatIs: 'Wat is PRP Haarbehandeling?',
    benefits: 'Voordelen van PRP Behandeling',
    procedure: 'De PRP Procedure',
    packages: 'PRP Behandelingspakketten',
    results: 'Wanneer Resultaten Verwachten',
    idealFor: 'Wie Moet PRP Overwegen?',
  },
  hero: {
    title: 'Haartransplantatie in Nederland',
    subtitle: 'FUE, DHI & Saffier haartransplantatie — uitgevoerd door ervaren specialisten. Natuurlijke resultaten. Vanaf €1.500. Gratis consult in Den Haag & Amsterdam.',
    bookConsultation: 'Boek Gratis Consult',
    whatsapp: 'WhatsApp Ons',
  },
  services: {
    title: 'Onze Premium Haarherstel Services',
    subtitle: 'Geavanceerde technieken die Turkse expertise combineren met Europese kwaliteitsnormen',
  },
  results: {
    title: 'Patiëntvoorbeelden en Verwacht Verloop',
    subtitle: 'Illustratieve voorbeelden van eerdere patiënten. Individuele resultaten variëren en zijn afhankelijk van donorgebied, haaruitvalpatroon, gezondheid, techniek en nazorg.',
  },
  locations: {
    title: 'Handige Locaties Door Heel Europa',
    subtitle: 'Premium zorg in ultramoderne faciliteiten',
  },
  contact: {
    title: 'Start Uw Haarherstel Reis',
    subtitle: 'Boek vandaag uw gratis consult',
    name: 'Volledige Naam',
    email: 'Email',
    phone: 'Telefoonnummer',
    treatment: 'Geïnteresseerd In',
    message: 'Vertel ons over uw haarverlies zorgen',
    send: 'Verstuur Bericht',
    sending: 'Verzenden...',
  },
  footer: {
    about: 'Hair Art Clinics combineert Turkse medische excellentie met Europese kwaliteitsnormen en biedt premium haarhersteldiensten via onze partnerkliniek in Turkije, met advies vanuit Den Haag, Nederland.',
    quickLinks: 'Snelle Links',
    contactInfo: 'Contact Informatie',
    followUs: 'Volg Ons',
    rights: 'Alle rechten voorbehouden.',
  },
  treatments: {
    categories: {
      hairTransplant: 'Haartransplantatie Technieken',
      facialHair: 'Gezichtshaarherstel',
      revision: 'Revisie en Correctie',
      nonSurgical: 'Niet-Chirurgische Behandelingen',
      additional: 'Aanvullende Diensten',
      guides: 'Informatie en Gidsen'
    },
    bookConsultation: 'Boek Gratis Consult',
    benefits: 'Voordelen',
    procedure: 'Procedure',
    recovery: 'Herstel Tijdlijn',
    pricing: 'Prijzen',
    faq: 'Veelgestelde Vragen',
    contraindications: 'Contra-indicaties',
    beforeAfter: 'Voor & Na Resultaten',
    before: 'Voor',
    after: 'Na',
    bookingSubtitle: 'Plan uw gratis consult met onze experts',
    preferredDate: 'Voorkeursdatum',
    selectDate: 'Selecteer een datum',
    bookingMessage: 'Vertel ons over uw haarzorgen en eventuele vragen',
    submitBooking: 'Boekingsaanvraag Indienen',
    bookingSuccess: 'Dank u! We nemen binnenkort contact met u op om uw afspraak te bevestigen.',
    category: 'Behandelingscategorieën',
    all: 'Alle Behandelingen',
    gallery: 'Voor/Na Galerij',
    resultsTitle: 'Onze Echte Resultaten',
    resultsSubtitle: 'Ontdek transformatieverhalen van duizenden tevreden patiënten',
    patientStories: 'Patiëntverhalen',
    viewDetails: 'Bekijk Details',
    grafts: 'grafts',
    age: 'Leeftijd',
    testimonial: 'Patiëntgetuigenis',
    allResults: 'Alle Resultaten',
    filterByProcedure: 'Filter op Procedure'
  },
  comparison: {
    title: 'FUE vs DHI vs Sapphire FUE',
    subtitle: 'Vergelijk haartransplantatie technieken om de perfecte methode voor u te vinden',
    compareTitle: 'Techniek Vergelijking',
    method: 'Methode',
    duration: 'Procedure Duur',
    recovery: 'Hersteltijd',
    scarring: 'Littekens',
    density: 'Haardichtheid',
    pain: 'Pijnniveau',
    cost: 'Prijsrange',
    bestFor: 'Het Beste Voor',
    fue: {
      name: 'FUE',
      duration: '6-8 uur',
      recovery: '7-10 dagen',
      scarring: 'Minimale micro-stipjes',
      density: 'Hoog',
      pain: 'Laag (lokale verdoving)',
      cost: '€2,500 - €4,500',
      bestFor: 'Grote gebieden, maximale grafts'
    },
    dhi: {
      name: 'DHI',
      duration: '8-10 uur',
      recovery: '5-7 dagen',
      scarring: 'Vrijwel geen',
      density: 'Zeer Hoog',
      pain: 'Minimaal',
      cost: '€3,500 - €5,500',
      bestFor: 'Precisiewerk, haarlijnontwerp'
    },
    sapphire: {
      name: 'Sapphire FUE',
      duration: '6-8 uur',
      recovery: '5-7 dagen',
      scarring: 'Minimaal',
      density: 'Zeer Hoog',
      pain: 'Laag',
      cost: '€3,000 - €5,000',
      bestFor: 'Natuurlijke resultaten, sneller herstel'
    },
    advantages: 'Belangrijkste Voordelen',
    disadvantages: 'Overwegingen',
    faqTitle: 'Veelgestelde Vragen'
  },
  blog: {
    title: 'Haarverzorging en Welzijn Blog',
    subtitle: 'Deskundig advies, behandelingsinformatie en succesverhalen van patiënten',
    categories: {
      all: 'Alle Artikelen',
      hairHealth: 'Haargezondheid',
      treatmentInfo: 'Behandelingsinformatie',
      patientStories: 'Patiëntenverhalen',
      clinicGuides: 'Kliniek Gidsen',
      procedures: 'Procedures'
    },
    readMore: 'Lees het volledige artikel',
    backToBlog: 'Terug naar Blog',
    recentPosts: 'Recente Posts',
    relatedPosts: 'Gerelateerde Artikelen',
    publishedOn: 'Gepubliceerd op',
    by: 'door',
    views: 'weergaven',
    noPostsFound: 'Geen artikelen gevonden',
    searchPlaceholder: 'Zoek artikelen...',
    admin: {
      title: 'Blogbeheer',
      newPost: 'Nieuw Artikel',
      editPost: 'Artikel Bewerken',
      deletePost: 'Artikel Verwijderen',
      published: 'Gepubliceerd',
      draft: 'Concept',
      title_label: 'Titel',
      slug_label: 'URL Slug',
      category_label: 'Categorie',
      excerpt_label: 'Excerpt',
      content_label: 'Inhoud',
      featuredImage_label: 'Afbeelding URL',
      isPublished_label: 'Publiceren',
      save: 'Opslaan',
      cancel: 'Annuleren',
      deleteConfirm: 'Weet u zeker dat u dit artikel wilt verwijderen?',
      viewOnSite: 'Bekijk op Site'
    }
  },
  error: "Fout",
  success: "Succes",
  admin: {
    dashboard: 'Admin Dashboard',
    overview: 'Overzicht en beheer',
    whatsapp: 'WhatsApp',
    liveSupport: 'Live Ondersteuning',
    leadManagement: 'Lead Beheer',
    blogManagement: 'Blog Beheer',
    calendarView: 'Kalender Weergave',
    gtmSetup: 'GTM Configuratie',
    totalBookings: 'Totaal Boekingen',
    pending: 'In Afwachting',
    confirmed: 'Bevestigd',
    cancelled: 'Geannuleerd',
    patientResults: 'Patiënt Resultaten',
    published: 'Gepubliceerd',
    thisMonth: 'Deze Maand',
    newBookings: 'Nieuwe boekingen',
    bookingTrend: 'Boekingstrend (Laatste 6 Maanden)',
    monthlyStats: 'Maandelijkse statistieken',
    bookingStatus: 'Boekingsstatus',
    statusDistribution: 'Verdeling per status',
    popularTreatments: 'Populaire Behandelingen',
    topTreatments: 'Top 5 meest gevraagde behandelingen',
    patientResultsManagement: 'Patiënt Resultaten Beheer',
    manageBeforeAfter: 'Beheer voor/na afbeeldingen en getuigenissen',
    addNewResult: 'Nieuw Resultaat Toevoegen',
    editResult: 'Patiënt Resultaat Bewerken',
    patientName: 'Patiënt Naam',
    age: 'Leeftijd',
    procedureType: 'Procedure Type',
    graftsCount: 'Aantal Grafts',
    surgeryDate: 'Operatie Datum',
    displayOrder: 'Weergave Volgorde',
    beforeImage: 'Voor Afbeelding',
    afterImage: 'Na Afbeelding',
    keepCurrentImage: 'Laat leeg om huidige afbeelding te behouden',
    testimonial: 'Getuigenis',
    doctorNotes: 'Dokter Notities',
    publishImmediately: 'Direct publiceren',
    cancel: 'Annuleren',
    uploading: 'Uploaden...',
    update: 'Bijwerken',
    create: 'Aanmaken',
    unpublish: 'Depubliceren',
    publish: 'Publiceren',
    draft: 'Concept',
    surgery: 'Operatie',
    order: 'Volgorde',
    noResults: 'Nog geen patiënt resultaten. Voeg de eerste toe!',
    deleteConfirm: 'Weet u zeker dat u dit resultaat wilt verwijderen?',
    leads: 'Lead Beheer',
    trackLeads: 'Volg uw potentiële klanten',
    downloadCSV: 'CSV Downloaden',
    totalLeads: 'Totaal Leads',
    hot: 'Heet',
    warm: 'Warm',
    cold: 'Koud',
    converted: 'Geconverteerd',
    sourceReport: 'Bron Rapport',
    conversions: 'conversies',
    searchPlaceholder: 'Zoeken op email, telefoon of naam...',
    allStatuses: 'Alle Statussen',
    new: 'Nieuw',
    contacted: 'Gecontacteerd',
    qualified: 'Gekwalificeerd',
    lost: 'Verloren',
    allSources: 'Alle Bronnen',
    filterSource: 'Filter op bron',
    leadList: 'Lead Lijst',
    loading: 'Laden...',
    noLeads: 'Geen leads gevonden',
    contact: 'Contact',
    source: 'Bron',
    score: 'Score',
    activities: 'Activiteiten',
    status: 'Status',
    date: 'Datum',
    actions: 'Acties',
    pageViews: 'Pagina Weergaven',
    formSubmissions: 'Formulier Inzendingen',
    pdfDownloads: 'PDF Downloads',
    chatInteractions: 'Chat Interacties',
    leadDetail: 'Lead Detail',
    name: 'Naam',
    email: 'Email',
    phone: 'Telefoon',
    utmParams: 'UTM Parameters',
    notes: 'Notities',
    saveNotes: 'Notities Opslaan',
    recentActivities: 'Recente Activiteiten',
    delete: 'Verwijderen',
    deleteLeadConfirm: 'Weet u zeker dat u deze lead wilt verwijderen?',
    initialEmail: 'Eerste Contact Email',
    followUpEmail: 'Opvolg Email',
    call: 'Bellen',
    manualEmail: 'Handmatige Email',
    bookingsCalendar: 'Boekingen Kalender',
    viewManageAppointments: 'Bekijk en beheer alle afspraken',
    sendReminders: 'Herinneringen Sturen',
    searchByNameEmailPhone: 'Zoeken op naam, email of telefoon...',
    filterByStatus: 'Filter op status',
    allTreatments: 'Alle Behandelingen',
    clearFilters: 'Filters Wissen',
    today: 'Vandaag',
    more: 'meer',
    selectDate: 'Selecteer een datum',
    noBookingsForDate: 'Geen boekingen voor deze datum',
    clickToView: 'Klik op een datum om boekingen te bekijken',
    reminded: 'Herinnerd',
    confirm: 'Bevestigen',
    accessDenied: 'Toegang Geweigerd',
    needAdminAccess: 'U heeft admin rechten nodig om deze pagina te openen.',
    goHome: 'Naar Home',
    galleryManagement: 'Galerij Beheer',
    backToGallery: 'Terug naar Galerij',
    uploadNewPhoto: 'Nieuwe Foto Uploaden',
    title: 'Titel',
    description: 'Beschrijving',
    altText: 'Alt Tekst (belangrijk voor SEO)',
    treatmentPage: 'Behandeling Pagina (Optioneel)',
    selectTreatment: 'Selecteer een behandeling (kan leeg blijven)',
    treatmentNote: 'Selecteer een behandeling om deze foto op die pagina te tonen.',
    photo: 'Foto',
    upload: 'Uploaden',
    uploadedPhotos: 'Geüploade Foto\'s',
    removeFromPublish: 'Depubliceren',
    generalGallery: 'Algemene Galerij (Geen behandeling)',
    emailTemplates: 'Email Sjablonen',
    manageEmailTemplates: 'Beheer automatische email sjablonen',
    newTemplate: 'Nieuw Sjabloon',
    templateKey: 'Sleutel',
    active: 'Actief',
    preview: 'Voorbeeld',
    edit: 'Bewerken',
    editTemplate: 'Sjabloon Bewerken',
    templateName: 'Sjabloon Naam',
    emailSubject: 'Email Onderwerp',
    htmlContent: 'HTML Inhoud',
    variablesNote: 'Variabelen: {{name}}, {{email}} kunnen worden gebruikt',
    save: 'Opslaan',
    close: 'Sluiten',
    createTemplate: 'Sjabloon Aanmaken',
    templateKeyUnique: 'Sjabloon Sleutel (uniek)',
    cms: 'Content Beheer',
    posts: 'Berichten',
    pages: 'Pagina\'s',
    media: 'Media',
    categories: 'Categorieën',
    settings: 'Instellingen',
  },
  hairAnalysis: {
    title: "AI Haaranalyse",
    subtitle: "Upload uw foto voor een AI-gebaseerde voorlopige haarbeoordeling. Dit is een screeningshulpmiddel en vervangt geen consult bij een gekwalificeerde arts.",
    uploadPhoto: "Upload Foto",
    uploadPhotoDesc: "Upload een duidelijke foto van uw haar voor analyse",
    clickToUpload: "Klik om afbeelding te uploaden",
    analyzeNow: "Nu Analyseren",
    analyzing: "Analyseren...",
    analysisResults: "Analyseresultaten",
    hairLossStage: "Haarverliestadium",
    estimatedGrafts: "Geschatte Grafts",
    recommendedTreatment: "Aanbevolen Behandeling",
    recommendations: "Aanbevelingen",
    detailedAnalysis: "Gedetailleerde Analyse",
    howItWorks: "Hoe Het Werkt",
    step1: "Upload een duidelijke frontale foto van uw haar",
    step2: "Onze AI analyseert uw haardichtheid en verliespatroon",
    step3: "Ontvang directe beoordeling met behandelingsaanbevelingen",
    step4: "Boek een consultatie met onze specialisten voor gedetailleerde planning",
    priceEstimate: "Geschatte Prijs",
    pricePerGraft: "Prijs per graft",
    priceNote: "* Definitieve prijs wordt bepaald tijdens consultatie",
    priceRange: 'Geschatte Prijsrange',
    bookViaWhatsApp: 'Boek via WhatsApp',
    whatsappMessage: 'WhatsApp Consultatie',
    getDetailedReport: 'Ontvang Gedetailleerd PDF Rapport',
    reportDescription: 'Ontvang een uitgebreid analyserapport met behandelingsaanbevelingen via e-mail',
    yourName: 'Uw Naam',
    yourEmail: 'Uw E-mail',
    enterName: 'Voer uw naam in',
    enterEmail: 'Voer uw e-mailadres in',
    sendReport: 'Stuur Rapport naar E-mail',
    sending: 'Verzenden...',
    reportDisclaimer: 'Gratis gedetailleerd PDF-rapport met behandelplan en prijzen',
    shareResults: 'Deel Uw Resultaten',
    shareDescription: 'Deel uw analyseresultaten met vrienden en familie',
    shareNote: '* Instagram: Tekst wordt naar klembord gekopieerd',
  },
  auth: {
    seoTitle: 'Inloggen & Registreren - Patiëntenportaal | Hair Art Clinics',
    seoDescription: 'Toegang tot uw Hair Art Clinics patiëntenportaal. Log in om medische dossiers en behandelfotos te bekijken en afspraken te beheren.',
    welcome: 'Welkom',
    welcomeSubtitle: 'Log in om het patiëntenportaal te openen of maak een nieuw account aan',
    forgotTitle: 'Wachtwoord vergeten',
    forgotSubtitle: 'Voer uw e-mail in om een resetlink te ontvangen',
    resetTitle: 'Wachtwoord opnieuw instellen',
    resetSubtitle: 'Voer uw nieuwe wachtwoord in',
    login: 'Inloggen',
    signup: 'Registreren',
    email: 'E-mail',
    password: 'Wachtwoord',
    newPassword: 'Nieuw wachtwoord',
    confirmNewPassword: 'Bevestig nieuw wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    fullName: 'Volledige naam',
    signIn: 'Inloggen',
    createAccount: 'Account aanmaken',
    updatePassword: 'Wachtwoord bijwerken',
    sendResetLink: 'Resetlink verzenden',
    backToLogin: 'Terug naar inloggen',
    orContinueWith: 'Of ga verder met',
    continueWithGoogle: 'Doorgaan met Google',
    forgotYourPassword: 'Wachtwoord vergeten?',
  },
  clinic: {
    city: 'Den Haag',
    country: 'Nederland',
    region: 'Zuid-Holland',
    hoursLabel: 'Openingstijden',
    hoursDaily: 'Elke dag',
  },
};
